<div class="row">
  <div class="col-sm order-sm-first">
    @if (show_action) {
      <button tabindex="{{actionTabIndex}}" class="btn c-button c-button--inverse" type="button" (click)="onAction()" [disabled]="disabled">
        {{action_title}}
        <svg class="c-button__icon c-button__icon--right icon-plus--small" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24">
          <path fill="#fff" d="M24 10H14V0h-4v10H0v4h10v10h4V14h10v-4z" />
        </svg>
      </button>
    }
  </div>
</div>
<div class="row mt-sm-4">
  <div class="col-sm order-sm-last">
    @if (show_forward) {
      <button tabindex="{{forwardTabIndex}}" type="submit" [ngClass]="{'c-button--inactive': forward_disabled, 'c-button--accent': !forward_disabled}" class="btn c-button float-md-right" (click)="onForward()" [disabled]="disabled">
        @if (!is_loading) {
          {{forward_title}}
        }
        @if (is_loading) {
          <b>Loading</b> - Please wait
        }
        <svg class="c-button__icon c-button__icon--right icon-arrow-right" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 8.06 14.71">
          <path fill="none" stroke="#2f3432" stroke-miterlimit="10" d="M.35 14.35l7-7-7-7" />
        </svg>
      </button>
    }
  </div>
  <div class="col-sm order-sm-first">
    @if (show_backward) {
      <button tabindex="{{backwardTabIndex}}" type="submit" [ngClass]="{'c-button--inactive': backward_disabled, 'c-button--neutral': !backward_disabled}" class="btn c-button c-button--neutral" type="button" (click)="onBackward()" [disabled]="backward_disabled">
        {{backward_title}}
        <svg class="c-button__icon c-button__icon--left icon-arrow-left" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 8.06 14.71">
          <path fill="none" stroke="#3F2B56" stroke-miterlimit="10" d="M7.71.35l-7 7 7 7" />
        </svg>
      </button>
    }
    @if (show_backward_icon) {
      <button tabindex="{{backwardTabIndex}}" type="submit"  class="c-button c-button--neutral" type="button" (click)="onBackward()" [disabled]="backward_disabled">
        {{backward_title}}
        <svg class="c-button__icon c-button__icon--right icon-document" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 25"><path fill="none" stroke="#000" stroke-miterlimit="10" d="M.5 23.37V.5h18.75l1.25 1.26v18.67l-4.04 4.07H1.49L.5 23.37z"></path><path fill="none" stroke="#3f2b56" stroke-miterlimit="10" d="M14.33 23.4v-5.65h5.03M4.22 4.74h12.56M4.22 8.63h12.56M4.22 12.65h12.56"></path></svg>
      </button>
    }
  </div>
</div>
